import script from "./PriceRangeField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceRangeField.vue?vue&type=script&setup=true&lang=ts"

import "./PriceRangeField.vue?vue&type=style&index=0&id=5ed50c3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed50c3c"]])

export default __exports__